import React from 'react';
import markImg from '../assets/logo-mark.png';

const TAGLINE = 'Play. Book. Manage.';

/**
 * Brand logo: colourful pin emblem + live "Groundaale" wordmark.
 *
 * The wordmark is rendered as live text (not a baked-in PNG) so it always
 * matches the active theme: "Ground" uses --ga-text-primary (light on dark,
 * dark on light) and "aale" uses the brand green --ga-primary. This keeps the
 * mark crisp at any size and locked to one green token across the app.
 *
 * Props:
 *  - className: wrapper classes
 *  - showText:  set false to render the emblem only (tight spaces)
 *  - showTagline: render "Play. Book. Manage." under the wordmark
 *  - size:      'sm' | 'md' | 'lg' — controls emblem + text scale
 */
const SIZES = {
  sm: { mark: 'h-7 w-7', text: 'text-lg', tagline: 'text-[8px] tracking-[0.16em]', rule: 'w-2' },
  md: { mark: 'h-8 w-8', text: 'text-xl', tagline: 'text-[10px] tracking-[0.18em]', rule: 'w-3' },
  lg: { mark: 'h-12 w-12', text: 'text-3xl', tagline: 'text-xs tracking-[0.2em]', rule: 'w-4' },
};

const Logo = ({ className = '', showText = true, showTagline = false, size = 'md' }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className={`flex items-center gap-2 min-w-0 ${className}`}>
      <img
        src={markImg}
        alt="Groundaale"
        className={`${s.mark} shrink-0 object-contain`}
      />
      {showText && (
        <div className="min-w-0">
          <span className={`block font-extrabold italic tracking-tight ${s.text} leading-none`}>
            <span className="text-ga-text-primary">Ground</span>
            <span className="text-ga-primary">aale</span>
          </span>
          {showTagline ? (
            <div className={`mt-1 flex items-center gap-1.5 ${s.tagline} font-semibold uppercase text-ga-text-subtle`}>
              <span className={`h-px shrink-0 ${s.rule} bg-ga-primary/70`} aria-hidden="true" />
              <span className="truncate">{TAGLINE}</span>
              <span className={`h-px shrink-0 ${s.rule} bg-ga-primary/70`} aria-hidden="true" />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Logo;
